import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'SocialIconLink' })((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 0,
  },
  large: {
    fontSize: theme.typography.pxToRem(28),
  },
  medium: {
    fontSize: theme.typography.pxToRem(21),
  },
  small: {
    fontSize: theme.typography.pxToRem(14),
  },
}));

export default useStyles;
